module.exports = "/_next/static/images/logo-different@2x-bcdb6ac2949813a70bc8cc217de83920.png";